// extracted by mini-css-extract-plugin
module.exports = {"target":"marketTip_target__1M3c5"};